import React from 'react'
// libs
import styled from 'styled-components'
// components
import { MaterialDesignContent, SnackbarProvider } from 'notistack'
// themes
import { colors } from 'themes/index'
// views
import { CircularProgressIcon } from './views'

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-success': {
    backgroundColor: colors.purple400
  },
  '&.notistack-MuiContent-info': {
    backgroundColor: colors.purple400
  }
}))

const anchorOrigin = {
  vertical: 'top' as const,
  horizontal: 'center' as const
}

const iconVariant = {
  success: <CircularProgressIcon size={20} />
}

const styleOverrides = {
  info: StyledMaterialDesignContent,
  success: StyledMaterialDesignContent
}

const SnackbarProviderContainer = ({ children }) => (
  <SnackbarProvider
    maxSnack={3}
    preventDuplicate
    autoHideDuration={2000}
    iconVariant={iconVariant}
    Components={styleOverrides}
    anchorOrigin={anchorOrigin}>
    {children}
  </SnackbarProvider>
)

export default SnackbarProviderContainer
